import { render, staticRenderFns } from "./ResponseForm.vue?vue&type=template&id=63ac5ca8&scoped=true&"
import script from "./ResponseForm.vue?vue&type=script&lang=js&"
export * from "./ResponseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ac5ca8",
  null
  
)

export default component.exports